module.exports = __webpack_public_path__ + "img/report-active.03a84873.svg";